<app-breadcrumb 
  [title]="'Nueva empresa'" 
  [items]="['Comercial', 'Empresas']" 
  [active_item]="'Nueva Empresa'">
</app-breadcrumb>
<div class="container-fluid">
<div class="card">
  <div class="card-header d-flex align-items-center bg-primary text-white">
    <i class="icofont icofont-verification-check me-2"></i>
    <h5 class="mb-0"><strong>DATOS EMPRESA</strong></h5>
  </div>

  <div class="card-body">
    <form [formGroup]="formEmpresa">
      <div class="row g-3">
        <div class="col-md-3">
          <label class="form-label" for="nit"><strong>CC / NIT *:</strong></label>
          <input
            #inputNit
            class="form-control"
            id="nit"
            type="number"
            placeholder="Ingrese CC o NIT *:"
            required
            formControlName="nit"
            [class.is-invalid]="formEmpresa.get('nit')?.invalid && validate"
          />
          <div *ngIf="formEmpresa.get('nit')?.invalid && validate" class="invalid-feedback">
            Por favor, ingresa un número de documento.
          </div>
        </div>
        

          <div class="col-md-3">
            <label class="form-label" for="digito">
              <strong>Digito de Verificacción *:</strong></label
            >
            <input
              #inputCodigo
              class="form-control"
              id="digito"
              required
              placeholder="Ingrese el dígito de verificación"
              formControlName="digito"
              [class.is-invalid]="formEmpresa.get('digito')?.invalid && validate"
            />
            <div *ngIf="formEmpresa.get('digito')?.invalid && validate" class="invalid-feedback">
               Por favor, ingresa un digito de verificación.
            </div>
          </div>

          <div class="col-md-3">
            <label class="form-label" for="nombre"><strong>Nombre Completo/Razon Social *:</strong></label>
            <input
              #inputNombre
              class="form-control"
              id="nombre"
              type="text"
              placeholder="Ingrese el nombre o razon social"
              required
              formControlName="nombre"
              [class.is-invalid]="formEmpresa.get('nombre')?.invalid && validate"
            />
            <div *ngIf="formEmpresa.get('nombre')?.invalid && validate" class="invalid-feedback">
              Por favor, ingresa un número de documento.
            </div>
          </div>

          <div class="col-md-3">
            <label class="form-label" for="direccion">
                <strong>Dirección *:</strong></label
            >
            <input
              #inputDireccion
              class="form-control"
              id="direccion"
              type="text"
              required
              placeholder="Ingresa una dirección"
              formControlName="direccion"
              [class.is-invalid]="formEmpresa.get('direccion')?.invalid && validate"
            />
             <div *ngIf="formEmpresa.get('direccion')?.invalid && validate" class="invalid-feedback">
                Por favor, ingresa una dirección.
            </div>
          </div>
          <div class="col-md-3">
             <label class="form-label" for="ciudad"
                    ><strong>Ciudad *:</strong></label
                  >
                  <ng-select
                    #inputCiudad
                    id="ciudad"
                    [items]="municipios"
                    bindLabel="MUNICIPIO"
                    bindValue="IDMUN"
                    placeholder="Selecciona una ciudad"
                    class="js-example-placeholder-multiple"
                    name="lugarex"
                    required
                    formControlName="ciudad"
                    [class.is-invalid]="formEmpresa.get('ciudad')?.invalid && validate"
                  ></ng-select>
       
              <div *ngIf="formEmpresa.get('ciudad')?.invalid && validate" class="invalid-feedback">
                Por favor, ingresa una ciudad.
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label" for="telefono"><strong>Teléfono fijo:</strong></label>
              <input
                type="tel"
                class="form-control"
                id="telefono"
                placeholder="Ingresa el teléfono fijo"
                formControlName="telefono"
                maxlength="10"
                pattern="\d{7,10}"
                title="Ingresa un número de 7 a 10 dígitos"
                (keypress)="permitirSoloNumeros($event)"
              />


          </div>
          <div class="col-md-3">
            <label class="form-label" for="celular"><strong>Teléfono celular *:</strong></label>
            <input
              #inputCelular
              class="form-control"
              id="celular"
             
              inputmode="numeric"
              placeholder="Ingresa el teléfono celular"
              formControlName="celular"
              required
              maxlength="10"
                pattern="\d{7,10}"
                title="Ingresa un número de 7 a 10 dígitos"
                (keypress)="permitirSoloNumeros($event)"
              [class.is-invalid]="formEmpresa.get('celular')?.invalid && validate"
            />
              <div *ngIf="formEmpresa.get('celular')?.invalid && validate" class="invalid-feedback">
                Por favor, ingresa un número de celular.
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label" for="email">
                <strong>Correo electrónico :</strong></label
            >
            <input
              #inputEmail
              class="form-control"
              id="email"
              type="text"
              
              placeholder="Ingresa un correo valido"
              formControlName="email"
              [class.is-invalid]="formEmpresa.get('email')?.invalid && validate"
            />
              <div *ngIf="formEmpresa.get('email')?.invalid && validate" class="invalid-feedback">
                Por favor, ingresa un correo electronico.
            </div>
          </div>

          <div class="row g-3 mb-3">
            <div class="mb-3">
              <label><strong>Observaciones:</strong></label>
              <textarea 
              class="form-control" 
              id="observaciones" rows="3"               
              formControlName="observaciones"></textarea>
            </div>
          </div>
          
      </div>

    </form>
  </div>
</div>

  
<div class="card">
  <form [formGroup]="formEmpresa">
  <div class="card-header d-flex align-items-center bg-primary text-white">
    <i class="icofont icofont-verification-check me-2"></i>
    <h5 class="mb-0"><strong>TIPO DE EMPRESA</strong></h5>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-md-4">
        <label class="d-block" for="chk-ani1">
          <input class="checkbox_animated me-2" id="chk-ani1" type="checkbox" formControlName="eps"><strong>EPS (SALUD)</strong>
        </label>
        <label class="d-block" for="chk-ani2">
          <input class="checkbox_animated me-2" id="chk-ani2" type="checkbox" formControlName="arl"><strong>ARL (RIEGOS LABORALES)</strong>
        </label>
        <label class="d-block" for="chk-ani3">
          <input class="checkbox_animated me-2" id="chk-ani3" type="checkbox" formControlName="afp" ><strong>AFP (FONDO DE PENSIONES)</strong>
        </label>
        <label class="d-block" for="chk-ani4">
          <input class="checkbox_animated me-2" id="chk-ani4" type="checkbox" formControlName="ces"><strong>CES (CESANTIAS)</strong>
        </label>
        <label class="d-block" for="chk-ani5">
          <input class="checkbox_animated me-2" id="chk-ani5" type="checkbox" formControlName="ccf"><strong>CCF (CAJA DE COMPESANCIÓN FAMILIAR)</strong>
        </label>
        <label class="d-block" for="chk-ani6">
          <input class="checkbox_animated me-2" id="chk-ani6" type="checkbox" formControlName="bancos"><strong>BANCOS</strong>
        </label>
      </div>
      <div class="col-md-4">
        <label class="d-block" for="chk-ani7">
          <input class="checkbox_animated me-2" id="chk-ani7" type="checkbox" formControlName="transporte"><strong>EMPRESA DE TRANSPORTES</strong>
        </label>
        <label class="d-block" for="chk-ani8">
          <input class="checkbox_animated me-2" id="chk-ani8" type="checkbox" formControlName="colegio"><strong> COLEGIOS</strong>
        </label>
        <label class="d-block" for="chk-ani9">
          <input class="checkbox_animated me-2" id="chk-ani9" type="checkbox" formControlName="cda"><strong> CDA</strong>
        </label>
        <label class="d-block" for="chk-ani10">
          <input class="checkbox_animated me-2" id="chk-ani10" type="checkbox" formControlName="taller"><strong> TALLER MECÁNICO</strong>
        </label>
        <label class="d-block" for="chk-ani11">
          <input class="checkbox_animated me-2" id="chk-ani11" type="checkbox" formControlName="eds"><strong> EDS</strong>
        </label>
        <label class="d-block" for="chk-ani12">
          <input class="checkbox_animated me-2" id="chk-ani12" type="checkbox" formControlName="contratista"><strong> CLIENTES/CONTRATANTES</strong>
        </label>
      </div>
      <div class="col-md-4">
        <label class="d-block" for="chk-ani13">
          <input class="checkbox_animated me-2" id="chk-ani13" type="checkbox" formControlName="proveedor"><strong> PROVEEDOR</strong>
        </label>
        <label class="d-block" for="chk-ani14">
          <input class="checkbox_animated me-2" id="chk-ani14" type="checkbox" formControlName="aseguradora"><strong> ASEGURADORA</strong>
        </label>
   <!--      <label class="d-block" for="chk-ani15">
          <input class="checkbox_animated me-2" id="chk-ani15" type="checkbox" formControlName="eds"><strong>EDS</strong>
        </label> -->
        <label class="d-block" for="chk-ani16">
          <input class="checkbox_animated me-2" id="chk-ani16" type="checkbox" formControlName="almacen"><strong> ALMACÉN DE REPUESTO</strong>
        </label>
        <label class="d-block" for="chk-ani17">
          <input class="checkbox_animated me-2" id="chk-ani17" type="checkbox" formControlName="serviteca"><strong> SERVITECAS</strong>
        </label>
        <label class="d-block" for="chk-ani18">
          <input class="checkbox_animated me-2" id="chk-ani18" type="checkbox" formControlName="entidad"><strong> ENTIDAD</strong>
        </label>
      </div>
    </div>
  </div>
  </form>
</div>

  <div class="btn-showcase my-4">
    <button type="submit" class="btn btn-primary" (click)="guardarEmpresas()">
      GUARDAR
    </button>
  </div>